import { ACTIVITY_STATE_ALL_VALUE } from "components/filters/ToggleActivityStateFilter";
import { AppList } from "components/list/AppList";
import { ALL_ROWS_PER_PAGE_OPTION } from "components/list/pagination";
import React, { useState } from "react";
import { Datagrid, EditButton, TextField, Title, useTranslate, FunctionField } from "react-admin";

import { EmptyEx } from "../../../components/_extensions/react-admin/ra-ui-materialui/src/list/EmptyEx";
import { DatagridWithBlockDeleteProps } from "../../../components/_helpers/props/DatagridProps";
import { stylesForColorInheritInList } from "../../../components/_helpers/useStyles";
import { PhoneField } from "../../../components/fields/PhoneField";
import { StyledEmailField } from "../../../components/fields/StyledEmailField";
import { UserTypeField } from "../../../components/fields/UserTypeField";
import { YesNoField } from "../../../components/fields/YesNoField";
import { ScrollingWrapper } from "../../../components/ScrollingWrapper";
import { HideBlockUnblockButtonIfDeleted } from "../../../components/toolbars/BlockUnblockButton";
import DeleteRestoreButtons from "../../../components/toolbars/DeleteRestoreButtons";
import { useOwnerCompanyDataContext } from "../../../contexts/OwnerCompanyDataProvider";
import { OsfcUsersActions } from "./Actions";
import { ManagersFilter } from "./ListFilters";
import { CopySettingsButton } from "../../../components/buttons/CopySettingsButton";
import { CopySettingsDialog } from "../../../components/dialogs/CopySettingsDialog";
import { CopyUserSettingsProvider } from "contexts/CopyUserSettingsContext";

const defaultSort = { field: "id", order: "DESC" };
const filterDefaultValues = { activity_state: ACTIVITY_STATE_ALL_VALUE };

export const ManagersList = (props) => {
	const classes = stylesForColorInheritInList();
	const translate = useTranslate();
	const { ownerCompanyData } = useOwnerCompanyDataContext();

	const resourceName = translate(`resources.${props.resource}.name`, {
		company_name: ownerCompanyData.short_name,
	});
	const defaultEmptyMessage = translate("ra.page.empty", { name: resourceName });

	return (
		<CopyUserSettingsProvider>
			<CopySettingsDialog />
			<AppList
				{...props}
				sort={defaultSort}
				perPage={50}
				rowsPerPageOptions={[50, 100, ALL_ROWS_PER_PAGE_OPTION]}
				exporter={false}
				bulkActionButtons={false}
				filters={<ManagersFilter />}
				filterDefaultValues={filterDefaultValues}
				classes={classes}
				actions={<OsfcUsersActions />}
				title={resourceName}
				empty={<EmptyEx defaultEmptyMessage={defaultEmptyMessage} />}
			>
				<ScrollingWrapper>
					<Datagrid {...DatagridWithBlockDeleteProps}>
						<TextField source="id" />
						<TextField source="first_name" />
						<TextField source="last_name" />
						<StyledEmailField source="email" />
						<PhoneField source="phone" />
						<UserTypeField source="type" sortable={false} />
						<YesNoField source="is_terminal" />
						<YesNoField source="access_to_export" />
						<YesNoField source="access_to_task_force" />
						<YesNoField source="can_edit_completed_order" sortable={false} />
						<FunctionField
								label={translate('pages.settings.name')}
								sortable={false}
								render={(record) => <CopySettingsButton record={record} />}
							/>
						<EditButton label="" />
						<HideBlockUnblockButtonIfDeleted entity={"user"} />
						<DeleteRestoreButtons
							replaceResource="user-is-deleted"
							confirmDeleteStringKey="osfc.dialogs.confirm_delete_user"
							confirmRestoreStringKey="osfc.dialogs.confirm_restore_user"
						/>
					</Datagrid>
				</ScrollingWrapper>
			</AppList>
		</CopyUserSettingsProvider>
	);
};
